import "../settings.scss";

const Title = ({ title }) => {
  return <p className="title">{title}</p>;
};

export default Title;
